import React, { useRef, useEffect } from 'react';
import { useAppState } from "../RetailerFitGuide_StateContext.jsx";
import RetailerFitGuide_CarSelector from '../Shared/RetailerFitGuide_CarSelector.jsx';
import RetailerFitGuide_Solutions from './RetailerFitGuide_Solutions.jsx';
import RetailerFitGuide_RefitResult from './RetailerFitGuide_RefitResult.jsx';
import { Link } from 'react-router-dom';
import { TRACK_EVENT_TYPE } from '../Script/RetailerFitGuide_Constants.js';
const RetailerFitGuide_Refit = () => {
    const {
        selectedSolution,
        setSelectedSolution,
        oldCarResult,
        newCarResult,
        setOldCarResult,
        setNewCarResult,
        translations,
    } = useAppState();

    const oldCarSelectorRef = useRef(null);
    const newCarSelectorRef = useRef(null);

    const handleReset = () => {
        setSelectedSolution(null);
        oldCarSelectorRef.current.resetSelection();
        newCarSelectorRef.current.resetSelection();
    };
    const onClickOldCar = () => {
        setNewCarResult(null);
        setSelectedSolution(null);
        oldCarSelectorRef.current.unlockSelection();
    }

    return (
        <div className='retailerFitGuide_Refit'>
            {oldCarResult && newCarResult && selectedSolution && <div className="refit__title"><h1 className="heading3 mb-0">{translations.result}</h1><Link onClick={handleReset} className="refit__close" to={"/"}><i className="le-icon-x"></i><span className="sr-only">{translations.close}</span></Link></div>}
            {<RetailerFitGuide_CarSelector allowDiscontinued={true} journey={TRACK_EVENT_TYPE.REFIT} ref={oldCarSelectorRef} visible={!(oldCarResult && newCarResult && selectedSolution)} includeGenerationOld={true} solution={selectedSolution} result={oldCarResult} title={translations.selectOldCar} summaryText={translations.oldCar} setResult={setOldCarResult} />}
            <RetailerFitGuide_Solutions />
            {oldCarResult && <RetailerFitGuide_CarSelector allowDiscontinued={false} journey={TRACK_EVENT_TYPE.REFIT} ref={newCarSelectorRef} visible={selectedSolution && !newCarResult ? true : false} includeGenerationOld={false} title={translations.selectNewCar} summaryText={translations.newCar} result={newCarResult} setResult={setNewCarResult} />}
            <RetailerFitGuide_RefitResult reset={handleReset} openNewCar={() => newCarSelectorRef.current.unlockSelection()} openOldCar={onClickOldCar} />
        </div>
    );
};

export default RetailerFitGuide_Refit;